import Cookie from 'js-cookie'
const state = {
    isNag:false,
    banner:[],
    name:'',
    my_menu:[]
}
export default state;


// WEBPACK FOOTER //
// ./src/store/indexData/state.js